<script lang="ts">
  import { parseMargin, parseGap, getFlexPropsAsString, parseFlexProps } from '$lib/layout';
  import type { FlexProps, Gap, Margin } from '$types/layout';
  import { onMount } from 'svelte';

  export let justifyContent = 'space-between';
  export let alignItems = 'center';
  export let gap: string | Gap = '8px';
  export let direction = 'row';
  export let wrap = 'nowrap';
  export let width = 'fit-content';
  export let height = 'fit-content';
  export let margin: string | Margin = '0';
  export let breakpoints: { [key: number]: FlexProps } = [];

  let windowWidth: number;

  let mainProps: FlexProps = parseFlexProps({
    justifyContent,
    alignItems,
    gap,
    direction,
    wrap,
    width,
    height,
    margin
  });

  let parsedProps = getFlexPropsAsString(mainProps);

  onMount(() => {
    margin = parseMargin(margin);
    gap = parseGap(gap);
  });

  const breakpointKeys = Object.keys(breakpoints)
    .map((key) => parseInt(key))
    .sort((a, b) => b - a);

  $: mainProps = parseFlexProps({
    justifyContent,
    alignItems,
    gap,
    direction,
    wrap,
    width,
    height,
    margin
  });

  $: windowWidth,
    justifyContent,
    alignItems,
    gap,
    direction,
    wrap,
    width,
    height,
    margin,
    breakpoints,
    parseFlex();

  function parseFlex() {
    const breakpoint = breakpointKeys.find((key) => windowWidth > key);
    let props: FlexProps;
    if (breakpoint !== undefined) {
      props = breakpoints[breakpoint];
    } else {
      props = mainProps;
    }
    parsedProps = getFlexPropsAsString(props, mainProps);
  }
</script>

<svelte:window bind:innerWidth={windowWidth} />

<div class="flex" style={parsedProps}>
  <slot />
</div>

<style lang="scss">
  .flex {
    display: flex;
    justify-content: var(--justifyContent);
    align-items: var(--alignItems);
    gap: var(--gap);
    flex-direction: var(--direction);
    flex-wrap: var(--wrap);
    width: var(--width);
    height: var(--height);
    margin: var(--margin);
  }
</style>
